import { list } from "../../crud/notification.crud";

export const actionTypes = {
    NotificationsLoaded: "[Load Notifications] Notification API",
    ArchivedNotificationsLoaded: "[Load Archived Notifications] Notification API",
    NotificationRead: "[Read Notification] Notification API",
    NotificationArchived: "[Archive Notification] Notification API",
    NotificationRemoved: "[Remove Notification] Notification API",
};

const initialNotificationState = {
    notifications: [],
    archivedNotifications: [],
};

const sortByMostRecent = (notifications) => [...notifications].sort((first, second) => second.id - first.id);

export const reducer = (state = initialNotificationState, action) => {
    switch (action.type) {
        case actionTypes.NotificationsLoaded: {
            return {
                ...state,
                notifications: action.payload.notifications,
            };
        }

        case actionTypes.ArchivedNotificationsLoaded: {
            return {
                ...state,
                archivedNotifications: action.payload.notifications,
            };
        }

        case actionTypes.NotificationRead: {
            return {
                ...state,
                notifications: state.notifications.map((notification) => (notification.id === action.payload.id ? { ...notification, read: action.payload.read } : notification)),
            };
        }

        case actionTypes.NotificationArchived: {
            const { notification, archived } = action.payload;

            const notifications = state.notifications.filter((item) => item.id !== notification.id);
            const archivedNotifications = state.archivedNotifications.filter((item) => item.id !== notification.id);

            if (archived) {
                return {
                    ...state,
                    notifications,
                    archivedNotifications: sortByMostRecent([...archivedNotifications, { ...notification, archived: true }]),
                };
            }

            return {
                ...state,
                notifications: sortByMostRecent([...notifications, { ...notification, archived: false }]),
                archivedNotifications,
            };
        }

        case actionTypes.NotificationRemoved: {
            return {
                ...state,
                notifications: state.notifications.filter((item) => item.id !== action.payload.id),
                archivedNotifications: state.archivedNotifications.filter((item) => item.id !== action.payload.id),
            };
        }

        default:
            return state;
    }
};

export const actions = {
    fulfillNotifications: (notifications) => ({ type: actionTypes.NotificationsLoaded, payload: { notifications } }),
    fulfillArchivedNotifications: (notifications) => ({ type: actionTypes.ArchivedNotificationsLoaded, payload: { notifications } }),
    setNotificationRead: (id, read) => ({ type: actionTypes.NotificationRead, payload: { id, read } }),
    setNotificationArchived: (notification, archived) => ({ type: actionTypes.NotificationArchived, payload: { notification, archived } }),
    removeNotification: (id) => ({ type: actionTypes.NotificationRemoved, payload: { id } }),
};

let pendingRequest = null;

export const loadNotifications = async (dispatch) => {
    if (!pendingRequest) {
        pendingRequest = list().finally(() => {
            pendingRequest = null;
        });
    }

    const { data } = await pendingRequest;

    dispatch(actions.fulfillNotifications(data));
};

let pendingArchivedRequest = null;

export const loadArchivedNotifications = async (dispatch) => {
    if (!pendingArchivedRequest) {
        pendingArchivedRequest = list(true).finally(() => {
            pendingArchivedRequest = null;
        });
    }

    const { data } = await pendingArchivedRequest;

    dispatch(actions.fulfillArchivedNotifications(data));
};

export const getUnreadCount = (notifications) => notifications.filter((notification) => !notification.read).length;
